import { useAlertConfig, useAlertUiTranslation } from '../../../../../../hooks';
import { useFormRow } from '../../Components/useFormRow';
export function useDetailsPanel(config) {
    const { t } = useAlertUiTranslation();
    const { notificationOptions } = useAlertConfig();
    return {
        type: 'form.panel',
        style: {
            layout: 'column',
            paddingTop: config === null || config === void 0 ? void 0 : config.paddingTop,
            surface: 'level1',
        },
        children: [
            useFormRow([
                {
                    type: 'form.content',
                    key: 'content',
                    template: {
                        data: '',
                        content: `<div style="display: flex; align-items: center"> <span class="icon-message-outlined grey-700"></span> <p style="font-size: 20px; padding-left: 16px" class="subtitle1"> ${t('wizard.addMessage.details')} </p></div>`,
                    },
                },
                {
                    type: 'form.panel',
                    style: {
                        horizontalAlign: 'right',
                        paddingLeft: config.mode === 'edit' ? 56 : 49,
                    },
                    children: [
                        {
                            type: 'form.panel',
                            style: {
                                layout: 'responsive-sm',
                            },
                            children: [
                                {
                                    type: 'alert.sender',
                                    key: 'ownerId',
                                    label: t('wizard.addMessage.sender'),
                                    validate: {
                                        required: true,
                                        requiredMessage: t('common.required'),
                                    },
                                },
                                {
                                    type: 'form.select',
                                    key: 'messageType',
                                    label: t('wizard.addMessage.messageType'),
                                    valueProvider: {
                                        type: 'classifier.messageType',
                                    },
                                    defaultValue: notificationOptions && (notificationOptions === null || notificationOptions === void 0 ? void 0 : notificationOptions.messageType)
                                        ? notificationOptions.messageType
                                        : undefined,
                                    validate: {
                                        required: true,
                                        requiredMessage: t('common.required'),
                                    },
                                },
                            ],
                        },
                        {
                            type: 'form.panel',
                            children: [
                                {
                                    type: 'form.text',
                                    key: 'subject',
                                    label: t('wizard.addMessage.subject'),
                                    validate: {
                                        required: true,
                                        requiredMessage: t('common.required'),
                                    },
                                    tooltip: {
                                        text: t('wizard.addMessage.subjectTooltip'),
                                    },
                                },
                                {
                                    type: 'alert.messageInfo',
                                    key: 'alertInfo',
                                    hidden: {
                                        custom: (handler) => {
                                            var _a;
                                            const data = (_a = handler.up().up().down('messageType')) === null || _a === void 0 ? void 0 : _a.getData();
                                            return data == undefined;
                                        },
                                    },
                                },
                            ],
                        },
                    ],
                },
            ], config.mode),
        ],
    };
}
